import api_adm from "./api";
const endpoint = "volontariat/UtilisateurPgi";

/** @type {CrudService} */
export const PgiUserService = {
  async lister(filtre) {
    try {
      const result = await api_adm.get(endpoint + "/liste", {
        params: filtre,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async findOneById(id) {
    try {
      const result = await api_adm.get(endpoint + "/find_one", {
        params: { id: id },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async create(data) {
   throw new Error("Method not implemented.");
  },
  async list(data) {
   throw new Error("Method not implemented.");
  },
  async update(data) {
   throw new Error("Method not implemented.");
  },
  async softDelete(data) {
   throw new Error("Method not implemented.");
  },
  async hardDelete(data) {
   throw new Error("Method not implemented.");
  },
 async restore(data) {
   throw new Error("Method not implemented.");
  },
};
